import store from '@/store/store'
import axios from 'axios'
const forceCashOpen = async (to, from, next) => {
    let openCashDesk = store.state.AuthModule.openCashDesk
    let cashDeskID = store.state.AuthModule.cash_desk_id
    if (
        [
            'CashDesk',
            'customerPayment',
            'customerPaymentVerify',
            'CreditNote',
        ].includes(to.name) &&
        !openCashDesk
    ) {
        let route =
            process.env.VUE_APP_API_ROUTE +
            '/pos_daily_cash_initial_resume?pos_cash_desk_id=' +
            cashDeskID
        console.log(route)
        axios
            .get(route)
            .then(r => {
                store.dispatch('AuthModule/setOpenCashDesk', true)
                next()
                return
            })
            .catch(e => {
                next('/movement')
                return
            })
    } else {
        next()
    }
}

const arr = [forceCashOpen]

export default arr
